import React, { FC } from 'react';
import { motion } from 'framer-motion';
import { CandidateUIV2NavBar } from './CandidateUIV2NavBar';
import { CandidateUIV2Footer } from './CandidateUIV2Footer';
import { NextSeo } from 'next-seo';
import Utils from '../../utils/Utils';
import { DEFAULT_OG_IMAGES, SEO_COMMON } from '../candidate/CandidateLayout';

type Props = {
  title: string | React.ReactNode;
  children: React.ReactNode;
};

export const CandidateUIV2Layout: FC<Props> = ({ children, title }) => {
  return (
    <div className="min-h-screen flex w-full flex-col bg-white font-sans overflow-x-hidden">
      {/* Top Navbar */}
      {typeof title === 'string' ? (
        <NextSeo
          title={title}
          description="Hotjobs is the most popular job portal for jobs in Sri Lanka, and to find out the best top job vacancies in Sri Lanka to your career next growth step"
          additionalMetaTags={[{ name: 'keywords', content: 'Jobs in Sri Lanka | Hotjobs' }]}
          openGraph={{
            title: `${title} | Jobs in Sri Lanka | Job Vacancies in ${Utils.moment().format(
              'YYYY',
            )} | Hotjobs`,
            description:
              'Hotjobs is the most popular job portal for jobs in Sri Lanka, and to find out the best top job vacancies in Sri Lanka to your career next growth step',
            images: DEFAULT_OG_IMAGES,
          }}
          {...SEO_COMMON}
        />
      ) : (
        title
      )}
      <CandidateUIV2NavBar />

      {/* Content Wrapper */}
      <main className="flex-1 w-full">
        <div className="max-w-candidate-ui mx-auto px-4 md:px-6">{children}</div>
      </main>

      {/* Footer */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1.18, ease: 'easeOut' }}>
        <CandidateUIV2Footer />
      </motion.div>
    </div>
  );
};
